import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './chip.css';

/**
 * @property {'primary' || 'gradient' || 'accent' || 'warning' || 'success'} variant
 * @property {string} text
 */
export default class Chip extends TemplateElement {
    constructor() {
        super({ styles: [style], propertyOptions: { variant: { reflect: true } } });
    }

    properties() {
        return {
            variant: '',
            text: '',
        };
    }

    template() {
        return html`${this.text}`;
    }
}

defineElement('mb-chip', Chip);
